import React from "react";
import { defineMessages } from "react-intl";
import { Typography } from "@mui/material";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { InfoMessage } from "./InfoMessage.js";
const accessControlLocalized = defineMessages({
  notAccessibleMessage: {
    id: "notAccessibleMessage",
    defaultMessage: "Sorry, you do not have permission to view this module."
  }
});
function NoAccessInfoMessage({ message }) {
  return /* @__PURE__ */ React.createElement(InfoMessage, { dataTestId: "notAccessibleMessage" }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: message ?? accessControlLocalized.notAccessibleMessage })));
}
export {
  NoAccessInfoMessage
};
//# sourceMappingURL=NoAccessInfoMessage.js.map
